(function () {
    'use strict';

    angular.module('ib-pmt-order-confirmation-module', [
        'ib-pmt-utils-module',
        'ib-pmt-confirmation-info-module',
        'ib-pmt-reservation-car-module',
        'ib-pmt-hotels-module',
        'ib-pmt-carbon-footprint-module',
        'ib-pmt-wine-club-module',
        'ib-pmt-assistance-voucher-info-module',
        'ib-pmt-confirmation-carbon-footprint-module'
    ]);
})();
